var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFasterSmarterIlluBgD = function SvgFasterSmarterIlluBgD(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 617,
    height: 589,
    viewBox: "0 0 617 589",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "75.126%",
    x2: "3.474%",
    y1: "30.655%",
    y2: "86.52%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D3ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C56CD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M356.19 78.249c-47-54-66-85-120-77s-112 44-145 99-101 217-90 299 53 117 122 157 136 40 240 16 218-143 244-225-8-98-61-129-143-86-190-140z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "76.037%",
    x2: "17.954%",
    y1: "0%",
    y2: "93.166%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B262D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6B3FBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "71.727%",
    x2: "29.708%",
    y1: "0%",
    y2: "96.305%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7444C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B865D3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-6 380.914c78.333 35.334 149.667 33.334 214-6 96.5-59 161-162 170-306 6-96-67.667-137.963-221-125.891C33.667 152.283-28 270.248-28 296.914c0 26.667 7.333 54.667 22 84z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "nonzero",
    d: "M567.959 226C437.692 280.144 370.706 399.192 367 583.144L550.258 630l68.721-125.99L670 278.582 567.959 226z",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFasterSmarterIlluBgD);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/faster-smarter-illu-bg-d.4e3b6b0c0af09d9f0609afc4f8fc0ba8.svg";